import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../DataOps.css';
import ConsultingForm from '../../../Componet/Consulting/ConsultingForm';

const DataOps = () => {
    const scrollToForm = (e) => {
        if (e) e.preventDefault();
        const formElement = document.getElementById('epic-dataops-form');
        if (formElement) {
            formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <>
            <Helmet>
                <title>EpicFinal - שירותי DataOps לניהול תשתיות נתונים בארגון</title>
                <meta
                    name="description"
                    content="EpicFinal מסייעת לארגונים לבנות תשתיות DataOps מסודרות, אוטומטיות ואמינות, לשפר את זרימת המידע בין מערכות ולהפוך נתונים לתשתית תפעולית שמייצרת ערך עסקי."
                />
                <meta
                    name="keywords"
                    content="DataOps, data operations, data pipeline, אוטומציית נתונים, ETL, BI, אינטגרציית נתונים, טיוב נתונים"
                />
                <meta property="og:title" content="EpicFinal - שירותי DataOps לניהול תשתיות נתונים בארגון" />
                <meta
                    property="og:description"
                    content="EpicFinal מסייעת לארגונים לבנות תשתיות DataOps מסודרות, אוטומטיות ואמינות, לשפר את זרימת המידע בין מערכות ולהפוך נתונים לתשתית תפעולית שמייצרת ערך עסקי."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://epicfinal.com/he/dataops" />
                <meta property="og:locale" content="he_IL" />
                <meta property="og:site_name" content="EpicFinal" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="EpicFinal - שירותי DataOps לניהול תשתיות נתונים בארגון" />
                <meta
                    name="twitter:description"
                    content="EpicFinal מסייעת לארגונים לבנות תשתיות DataOps מסודרות, אוטומטיות ואמינות, לשפר את זרימת המידע בין מערכות ולהפוך נתונים לתשתית תפעולית שמייצרת ערך עסקי."
                />
            </Helmet>

            <div className="dataops-page" dir="rtl">

                {/* Hero */}
                <section className="dataops-hero">
                    <div className="dataops-hero-bg-elements">
                        <div className="dataops-orb dataops-orb-1"></div>
                        <div className="dataops-orb dataops-orb-2"></div>
                        <div className="dataops-orb dataops-orb-3"></div>
                    </div>
                    <div className="container">
                        <div className="dataops-hero-content">
                            <div className="dataops-icon-badge">
                                <i className="las la-database"></i>
                            </div>
                            <h1 className="dataops-hero-title">DataOps</h1>
                            <p className="dataops-hero-subtitle">
                                בונים תשתית חכמה לניהול, אוטומציה והזרמת נתונים בארגון.
                            </p>
                            <p className="dataops-hero-description">
                                אנחנו מסייעים לארגונים לארגן, לחבר ולייעל את תנועת הנתונים בין מערכות, כדי לייצר תהליכי עבודה נקיים יותר, בקרה מלאה ושליטה תפעולית טובה יותר.
                            </p>
                            <p className="dataops-hero-description secondary">
                                הופכים מידע מפוזר ותהליכים ידניים למערך נתונים אמין, רציף ומוכן לקבלת החלטות.
                            </p>
                            <div className="dataops-hero-buttons">
                                <button
                                    type="button"
                                    className="btn-dataops btn-primary"
                                    onClick={scrollToForm}
                                >
                                    השאירו פרטים
                                </button>
                                <a
                                    href="https://meetings.hubspot.com/viacheslav-seifer"
                                    className="btn-dataops btn-secondary"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    קבעו שיחת ייעוץ
                                </a>
                            </div>
                            <div className="dataops-hero-badges">
                                <span className="dataops-badge"><i className="las la-sync-alt"></i> אוטומציית נתונים</span>
                                <span className="dataops-badge"><i className="las la-check-double"></i> טיוב ובקרת איכות</span>
                                <span className="dataops-badge"><i className="las la-chart-bar"></i> מוכן ל-BI</span>
                                <span className="dataops-badge"><i className="las la-expand-arrows-alt"></i> תשתית סקיילבילית</span>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Promo Banner */}
                <section className="dataops-promo-banner">
                    <div className="dataops-promo-ticker">
                        {['SIEM', 'CRM', 'Logs', 'Events', 'APIs', 'Forms', 'BI', 'ETL', 'ELT', 'Webhooks', 'Databases', 'Spreadsheets'].map((t, i) => (
                            <span className="dataops-promo-ticker-item" key={i}>{t}</span>
                        ))}
                        {['SIEM', 'CRM', 'Logs', 'Events', 'APIs', 'Forms', 'BI', 'ETL', 'ELT', 'Webhooks', 'Databases', 'Spreadsheets'].map((t, i) => (
                            <span className="dataops-promo-ticker-item" key={`dup-${i}`} aria-hidden="true">{t}</span>
                        ))}
                    </div>
                    <div className="container">
                        <div className="dataops-promo-inner">
                            <div className="dataops-promo-left">
                                <div className="dataops-promo-eyebrow">
                                    <span className="dataops-promo-dot"></span>
                                    סנכרון נתונים הוא אתגר עסקי
                                </div>
                                <h2 className="dataops-promo-headline">
                                    <span className="dataops-promo-sources">CRM. גיליונות. טפסים. לוגים.</span>
                                    <br />
                                    <span className="dataops-promo-challenge">מערכות שונות.<br className="dataops-promo-br" /> אתגר אחד של נתונים מפוזרים.</span>
                                </h2>
                                <p className="dataops-promo-sub">
                                    כל מערכת בארגון מייצרת עוד נתונים, אבל ברוב המקרים המידע נשאר מפוזר, לא עקבי וקשה לניצול. אנחנו מאחדים, מטייבים ומזרימים את המידע שלכם כך שכלל הארגון יוכל לעבוד על בסיס נתונים אחיד, אמין ונגיש.
                                </p>
                                <button
                                    type="button"
                                    className="dataops-promo-btn"
                                    onClick={scrollToForm}
                                >
                                    <i className="las la-envelope"></i>
                                    בואו נדבר על תשתית הנתונים שלכם
                                </button>
                            </div>
                            <div className="dataops-promo-right">
                                <div className="dataops-promo-visual">
                                    {[
                                        { label: 'לידים וטפסים', icon: 'la-shield-alt', color: '#ef4444' },
                                        { label: 'מערכות CRM', icon: 'la-users', color: '#f59e0b' },
                                        { label: 'קריאות API', icon: 'la-plug', color: '#10b981' },
                                        { label: 'קבצי אקסל', icon: 'la-table', color: '#f97316' },
                                    ].map((src, i) => (
                                        <div
                                            className="dataops-promo-source-pill"
                                            key={i}
                                            style={{ '--pill-color': src.color, '--pill-delay': `${i * 0.15}s` }}
                                        >
                                            <span className="dataops-promo-source-icon" style={{ background: src.color }}>
                                                <i className={`las ${src.icon}`}></i>
                                            </span>
                                            <span className="dataops-promo-source-label">{src.label}</span>
                                            <span className="dataops-promo-source-arrow">
                                                <i className="las la-long-arrow-alt-left"></i>
                                            </span>
                                        </div>
                                    ))}
                                    <div className="dataops-promo-merge-node">
                                        <i className="las la-database"></i>
                                        <span>DataOps</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* What is DataOps */}
                <section className="dataops-what">
                    <div className="container">
                        <div className="dataops-section-header">
                            <h2>מהו בעצם DataOps?</h2>
                            <p>גישה תפעולית לניהול נתונים באופן יעיל, אוטומטי ואמין, שמחברת בין מקורות מידע, תהליכים עסקיים ומערכות החלטה.</p>
                        </div>
                        <div className="dataops-what-grid">
                            <div className="dataops-what-text">
                                <p>
                                    במקום קבצים מפוזרים, עדכונים ידניים ומקורות מידע שסותרים זה את זה, DataOps מייצר צינור נתונים מסודר שמאפשר להעביר מידע בצורה עקבית ממערכות המקור ועד לדוחות הניהול והבקרה.
                                </p>
                                <p>
                                    צוות הדאטה של EpicFinal מתכנן מחדש את מסע הנתונים בארגון, במטרה <strong>לצמצם מידע חסר, להפחית עבודה ידנית, לשפר את אמינות הנתונים ולהפיק מהם ערך עסקי ברור.</strong>
                                </p>
                            </div>
                            <div className="dataops-what-list">
                                <h3>פרויקט DataOps יכול לכלול:</h3>
                                <ul>
                                    <li><i className="las la-check"></i> איסוף וריכוז מידע ממספר מערכות ומקורות</li>
                                    <li><i className="las la-check"></i> סנכרון שוטף, טיוב וניקוי נתונים לפני אחסון ושימוש</li>
                                    <li><i className="las la-check"></i> אוטומציה של תהליכי עיבוד, העשרה והזנת נתונים</li>
                                    <li><i className="las la-check"></i> הקמת שכבת בקרת איכות ואימות נתונים</li>
                                    <li><i className="las la-check"></i> הזרמת מידע מעודכן ומוכן למערכות BI ודשבורדים</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Who is this for */}
                <section className="dataops-audience">
                    <div className="container">
                        <div className="dataops-section-header light">
                            <h2>למי הפתרון הזה מתאים?</h2>
                            <p>לארגונים שרוצים לעבוד עם הנתונים שלהם בצורה מסודרת, חכמה וניתנת להרחבה.</p>
                        </div>
                        <div className="dataops-audience-grid">
                            {[
                                { icon: 'la-sitemap', text: 'חברות שמקבלות מידע ממקורות רבים במקביל וזקוקות לזרימה תפעולית מסודרת.' },
                                { icon: 'la-users', text: 'ארגונים שמנהלים לידים, לקוחות ומכירות בכמה מערכות תוכנה במקביל.' },
                                { icon: 'la-file-excel', text: 'צוותים שמבזבזים זמן על תחזוקת גיליונות, עדכונים ידניים ותיקון שגיאות.' },
                                { icon: 'la-chart-line', text: 'מנהלים שצריכים דוחות אמינים ועדכניים כדי לקבל החלטות על בסיס נתונים.' },
                            ].map((item, i) => (
                                <div className="dataops-audience-card" key={i}>
                                    <div className="dataops-audience-icon">
                                        <i className={`las ${item.icon}`}></i>
                                    </div>
                                    <p>{item.text}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Services */}
                <section className="dataops-services">
                    <div className="container">
                        <div className="dataops-section-header">
                            <h2>שירותי האפיון, ההקמה וההטמעה שלנו</h2>
                            <p>אנחנו מתכננים תשתית DataOps בהתאם למערכות, לאילוצים ולצרכים העסקיים של הארגון שלכם.</p>
                        </div>
                        <div className="dataops-services-grid">
                            {[
                                {
                                    icon: 'la-project-diagram',
                                    title: 'ארכיטקטורת נתונים',
                                    desc: 'תכנון מסלול הזרימה הנכון לנתונים שלכם, מהמערכות התפעוליות ועד לשכבת הדיווח והבקרה.',
                                },
                                {
                                    icon: 'la-plug',
                                    title: 'אינטגרציות בין מערכות ומקורות מידע',
                                    desc: 'חיבור שוטף בין טפסים, מערכות פנימיות, APIs, שירותי צד שלישי ומקורות מידע דיגיטליים.',
                                },
                                {
                                    icon: 'la-broom',
                                    title: 'טיוב, ניקוי והאחדת נתונים',
                                    desc: 'זיהוי כפילויות, טיפול בערכים שגויים והגדרת כללים ברורים לשמירה על איכות הנתונים.',
                                },
                                {
                                    icon: 'la-sync-alt',
                                    title: 'אוטומציה של זרימות מידע',
                                    desc: 'צמצום תהליכים ידניים באמצעות אוטומציות שמזרימות נתונים באופן עקבי בין המערכות הארגוניות.',
                                },
                                {
                                    icon: 'la-search',
                                    title: 'בקרת איכות וניטור',
                                    desc: 'הגדרת בדיקות, בקרה שוטפת ומנגנוני התראה שמונעים שיבושים ועיוותים במידע העסקי.',
                                },
                                {
                                    icon: 'la-chart-bar',
                                    title: 'הכנת נתונים ל-BI',
                                    desc: 'בניית שכבת נתונים קריאה, מסודרת ואמינה, שמאפשרת למערכות BI לעבוד בצורה מדויקת ויעילה.',
                                },
                            ].map((s, i) => (
                                <div className="dataops-service-card" key={i}>
                                    <div className="dataops-service-icon">
                                        <i className={`las ${s.icon}`}></i>
                                    </div>
                                    <h3>{s.title}</h3>
                                    <p>{s.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Why Businesses Need DataOps */}
                <section className="dataops-why">
                    <div className="container">
                        <div className="dataops-why-inner">
                            <div className="dataops-why-text">
                                <h2>למה ארגונים צריכים DataOps?</h2>
                                <p>
                                    ארגונים אוספים כיום כמויות גדולות של נתונים, אבל ללא תהליך מסודר קשה מאוד לשלוט בהם, לנתח אותם ולהסתמך עליהם. <strong>בלי תשתית DataOps ברורה</strong>, נוצרות בעיות שפוגעות ישירות בביצועים העסקיים:
                                </p>
                                <ul className="dataops-problems-list">
                                    <li><i className="las la-times-circle"></i> כפילויות, סתירות ופערים בין מקורות מידע שונים</li>
                                    <li><i className="las la-times-circle"></i> נתונים קריטיים שמתעדכנים באיחור ולא תומכים בקבלת החלטות בזמן</li>
                                    <li><i className="las la-times-circle"></i> טעויות אנוש שנוצרות בתהליכים ידניים ובעדכונים חוזרים</li>
                                    <li><i className="las la-times-circle"></i> דשבורדים ודוחות שההנהלה מתקשה לסמוך עליהם</li>
                                    <li><i className="las la-times-circle"></i> החלטות עסקיות שמבוססות על מידע חלקי, מיושן או לא מדויק</li>
                                </ul>
                                <p className="dataops-why-conclusion">
                                    תשתית DataOps אמינה יוצרת <strong>סדר תפעולי, סקיילביליות ויכולת קבלת החלטות טובה ומהירה יותר.</strong>
                                </p>
                            </div>
                            <div className="dataops-why-visual">
                                <div className="dataops-flow-card">
                                    <div className="dataops-flow-step">
                                        <i className="las la-database"></i>
                                        <span>איסוף נתונים ממקורות שונים</span>
                                    </div>
                                    <div className="dataops-flow-arrow"><i className="las la-arrow-down"></i></div>
                                    <div className="dataops-flow-step">
                                        <i className="las la-cogs"></i>
                                        <span>עיבוד ואוטומציה של התהליכים</span>
                                    </div>
                                    <div className="dataops-flow-arrow"><i className="las la-arrow-down"></i></div>
                                    <div className="dataops-flow-step">
                                        <i className="las la-check-double"></i>
                                        <span>בקרת איכות ואימות נתונים</span>
                                    </div>
                                    <div className="dataops-flow-arrow"><i className="las la-arrow-down"></i></div>
                                    <div className="dataops-flow-step dataops-flow-step--highlight">
                                        <i className="las la-chart-line"></i>
                                        <span>תובנות עסקיות מוכנות ל-BI</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Why EpicFinal */}
                <section className="dataops-epicfinal">
                    <div className="container">
                        <div className="dataops-section-header">
                            <h2>למה לעבוד עם EpicFinal?</h2>
                            <p>אנחנו מחברים בין הבנה עסקית, ארכיטקטורת מערכות ויישום טכנולוגי כדי לייצר פתרונות DataOps שעובדים בפועל.</p>
                        </div>
                        <div className="dataops-epicfinal-grid">
                            {[
                                {
                                    icon: 'la-hammer',
                                    title: 'פתרונות פרקטיים עם השפעה ישירה',
                                    desc: 'אנחנו מתמקדים בפתרונות ישימים שמשרתים את הצוותים והמנהלים ביום-יום, ולא במצגות או ארכיטקטורות תיאורטיות.',
                                },
                                {
                                    icon: 'la-link',
                                    title: 'מבט מקצה לקצה על הפעילות',
                                    desc: 'אנחנו בוחנים את שרשרת הערך המלאה, מהמידע שנאסף בשטח ועד להחלטה העסקית שמתקבלת בהנהלה.',
                                },
                                {
                                    icon: 'la-server',
                                    title: 'תשתית יציבה שנבנית לצמיחה',
                                    desc: 'אנחנו מקימים מערכי נתונים עם בקרה, אבטחה וגמישות, כדי לאפשר לארגון לגדול בלי לייצר כאוס תפעולי חדש.',
                                },
                            ].map((r, i) => (
                                <div className="dataops-reason-card" key={i}>
                                    <div className="dataops-reason-icon">
                                        <i className={`las ${r.icon}`}></i>
                                    </div>
                                    <h3>{r.title}</h3>
                                    <p>{r.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Examples */}
                <section className="dataops-examples">
                    <div className="container">
                        <div className="dataops-section-header light">
                            <h2>דוגמאות לאתגרים שאנחנו פותרים</h2>
                            <p>מקרי שימוש נפוצים שבהם תשתית DataOps מדויקת מייצרת סדר, שקיפות ושליטה טובה יותר במידע.</p>
                        </div>
                        <div className="dataops-examples-list">
                            {[
                                'סנכרון לידים בין קמפיינים, מערכות שיווק, מוקדי מכירה ו-CRM, כך שכל גורם בארגון עובד על אותה תמונת מצב.',
                                'בניית מאגר נתונים מסודר עבור Power BI לצורך ניתוח עלויות, ביצועים ותפעול במספר סניפים או יחידות עסקיות.',
                                'הקמת תהליכי ETL ו-ELT שמרכזים, מטייבים ומעבירים נתונים לפני שימוש פיננסי, תפעולי או ניהולי.',
                                'חיבור מערכות ותיקות למוצרים דיגיטליים חדשים באמצעות APIs ואינטגרציות מותאמות.',
                                'הקמת מנגנוני בקרה ואימות שמונעים טעויות יקרות, חריגות ודיווחים לא אמינים.',
                            ].map((ex, i) => (
                                <div className="dataops-example-item" key={i}>
                                    <div className="dataops-example-num">{String(i + 1).padStart(2, '0')}</div>
                                    <p>{ex}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Our Process */}
                <section className="dataops-process">
                    <div className="container">
                        <div className="dataops-section-header">
                            <h2>איך נראה פרויקט DataOps אצלנו?</h2>
                            <p>אנחנו עובדים בתהליך מובנה שמאפשר לזהות צווארי בקבוק, להקים תשתית מדויקת ולהטמיע פתרון שמחזיק לאורך זמן.</p>
                        </div>
                        <div className="dataops-process-steps">
                            {[
                                {
                                    step: '01',
                                    title: 'מיפוי המצב הקיים ואבחון צרכים',
                                    desc: 'אנחנו מנתחים את מקורות המידע, התהליכים והחסמים הקיימים כדי להבין איפה נוצר אובדן זמן, כפילויות או כשלים.',
                                    icon: 'la-search',
                                },
                                {
                                    step: '02',
                                    title: 'תכנון הארכיטקטורה והתהליכים',
                                    desc: 'אנחנו מגדירים את תשתית ה-Data Pipeline, את כללי העבודה ואת מודל ההטמעה בהתאם לצרכים העסקיים והטכנולוגיים.',
                                    icon: 'la-drafting-compass',
                                },
                                {
                                    step: '03',
                                    title: 'פיתוח אינטגרציות והטמעה',
                                    desc: 'אנחנו מחברים את המערכות, בונים את האוטומציות ומוודאים שהמידע זורם בצורה מלאה, מדויקת ויציבה.',
                                    icon: 'la-code-branch',
                                },
                                {
                                    step: '04',
                                    title: 'ניטור, בקרה והרחבה עתידית',
                                    desc: 'לאחר העלייה לאוויר אנחנו מגדירים בקרה שוטפת, מנגנוני התראה ויכולת הרחבה לצרכים עסקיים עתידיים.',
                                    icon: 'la-chart-line',
                                },
                            ].map((p, i) => (
                                <div className="dataops-process-card" key={i}>
                                    <div className="dataops-process-step-badge">{p.step}</div>
                                    <div className="dataops-process-icon">
                                        <i className={`las ${p.icon}`}></i>
                                    </div>
                                    <h3>{p.title}</h3>
                                    <p>{p.desc}</p>
                                    {i < 3 && <div className="dataops-process-connector"></div>}
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Business Impact Note */}
                <section className="dataops-impact">
                    <div className="container">
                        <div className="dataops-impact-card">
                            <div className="dataops-impact-icon">
                                <i className="las la-lightbulb"></i>
                            </div>
                            <div className="dataops-impact-content">
                                <h3>DataOps הוא לא רק מונח טכנולוגי, אלא מנוע לשיפור תפעולי ועסקי</h3>
                                <p>
                                    המטרה בפרויקט DataOps איננה רק להחליף אקסלים או לחבר מערכות. המטרה היא להחזיר לארגון שליטה, לקצר זמני עבודה, לצמצם טעויות ולספק למנהלים תמונת מצב אמינה, עדכנית וישימה בלחיצת כפתור.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* CTA */}
                <section className="dataops-cta">
                    <div className="container">
                        <div className="dataops-cta-content">
                            <h2>מוכנים לעשות סדר בתשתיות הנתונים שלכם?</h2>
                            <p>
                                אם המידע בארגון שלכם מפוזר, דורש טיפול ידני או לא מספק בסיס אמין להחלטות, זה הזמן לבנות תשתית DataOps שעובדת נכון.
                            </p>
                            <p className="dataops-cta-tagline">
                                <strong>EpicFinal בונה פתרונות DataOps מותאמים לארגונים שרוצים שליטה טובה יותר במידע, תהליכים יעילים יותר והשפעה עסקית אמיתית.</strong>
                            </p>
                            <div className="dataops-cta-buttons">
                                <button
                                    type="button"
                                    className="btn-dataops btn-light"
                                    onClick={scrollToForm}
                                >
                                    השאירו פרטים
                                </button>
                                <a
                                    href="https://meetings.hubspot.com/viacheslav-seifer"
                                    className="btn-dataops btn-outline"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    קבעו שיחת ייעוץ
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                <ConsultingForm
                    language="he"
                    formId="epic-dataops-form"
                    conversionSendTo="AW-11461100984/5XhTCNr-rZgcELiLitkq"
                    conversionValue={1.0}
                />

            </div>
        </>
    );
};

export default DataOps;

